import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
const industries = [{
  id: 'manufacturing',
  title: 'Manufacturing',
  useCase: 'Track machinery, tools, and work-in-progress across production lines',
  products: ['Asset labels', 'Equipment plates', 'WIP tags'],
  image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80&w=800'
}, {
  id: 'facilities',
  title: 'Facilities Management',
  useCase: 'Maintain safety compliance and clear identification throughout buildings',
  products: ['Safety signs', 'Inspection labels', 'Fire door notices'],
  image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=800'
}, {
  id: 'electrical',
  title: 'Electrical & Data',
  useCase: 'Identify cables, circuits, and panels in complex installations',
  products: ['Cable markers', 'Panel labels', 'Warning signs'],
  image: 'https://images.unsplash.com/photo-1555664424-778a1e5e1b48?auto=format&fit=crop&q=80&w=800'
}, {
  id: 'warehousing',
  title: 'Warehousing & Logistics',
  useCase: 'Organise inventory locations and streamline picking operations',
  products: ['Rack labels', 'Floor markers', 'Barcode labels'],
  image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&q=80&w=800'
}];
export function IndustriesSection() {
  return <section className="py-16 bg-slate-50" data-id="element-331">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12" data-id="element-332">
        {/* Section Header - Reduced prominence */}
        <div className="max-w-2xl mb-10" data-id="element-333">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[#0052CC] font-semibold text-xs mb-3 uppercase tracking-widest" data-id="element-334">
            Built for your environment
          </motion.p>
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-4 leading-tight" data-id="element-335">
            Do we serve your industry?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-slate-500 leading-relaxed" data-id="element-336">
            From high-heat manufacturing lines to sterile facility corridors,
            our labels are engineered to perform where you need them most.
          </motion.p>
        </div>

        {/* Industry Grid - Reduced visual weight */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-337">
          {industries.map((industry, index) => <motion.a key={industry.id} href="#" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="group relative flex flex-col overflow-hidden rounded-xl bg-white border border-slate-200 hover:border-slate-300 hover:shadow-lg transition-all duration-300" data-id="element-338">
              {/* Image - Reduced height */}
              <div className="relative h-48 overflow-hidden" data-id="element-339">
                <img src={industry.image} alt={industry.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-340" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/70 via-[#0A1628]/10 to-transparent" data-id="element-341" />
                <h3 className="absolute bottom-4 left-6 text-2xl font-bold text-white" data-id="element-342">
                  {industry.title}
                </h3>
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col flex-grow" data-id="element-343">
                <p className="text-slate-600 text-base leading-relaxed mb-4 flex-grow" data-id="element-344">
                  {industry.useCase}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-slate-100" data-id="element-345">
                  <div className="text-sm text-slate-400" data-id="element-346">
                    {industry.products.slice(0, 2).join(', ')}
                  </div>
                  <div className="h-8 w-8 rounded-full bg-slate-100 flex items-center justify-center group-hover:bg-[#0052CC] transition-colors duration-300" data-id="element-347">
                    <ArrowRight className="h-4 w-4 text-slate-500 group-hover:text-white transition-colors" data-id="element-348" />
                  </div>
                </div>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}